import { Radio, Typography } from "@mui/material";

type Props = {
    optionVariant: string;
    index: number;
};

export default function OptionVariantIndicator({ optionVariant, index }: Props) {
    if (optionVariant === "radio")
        return <Radio size="small" checked={false} disabled sx={{ padding: 0, position: "relative", top: "3px" }} />;
    return <Typography variant="subtitle1">{index + 1}.</Typography>;
}
